import { getCurrWorkspaceAlias } from '@/utils/workspace';

import {
  type GooglePlayAppInfoT,
  type GooglePlayStoreInfo,
  IMPORT_STATE,
} from '../../features/Setting/Integrations/providers/types';
import { defaultAxios } from '..';

type GooglePlayStoreInfoDTO = {
  alias: string;
  app_info: GooglePlayAppInfoT;
  workspace_id: string;
};

const googlePlayService = {
  async createGooglePlayStoreInfo(
    app: GooglePlayAppInfoT,
  ): Promise<GooglePlayStoreInfo> {
    const wa = getCurrWorkspaceAlias();
    const res = await defaultAxios.post<GooglePlayStoreInfoDTO>(
      `/workspaces/${wa}/google_play/`,
      app,
    );
    return {
      alias: res.data.alias,
      app_info: res.data.app_info,
      workspace_id: res.data.workspace_id,
      import_state: IMPORT_STATE.FINISHED,
    };
  },
  async getGooglePlayStoreInfos(wa: string): Promise<GooglePlayStoreInfo[]> {
    const res = await defaultAxios.get<GooglePlayStoreInfoDTO[]>(
      `/workspaces/${wa}/google_play/`,
    );
    if (!res.data) return [];
    return res.data.map((d) => ({
      alias: d.alias,
      app_info: d.app_info,
      workspace_id: d.workspace_id,
      import_state: IMPORT_STATE.FINISHED,
    }));
  },
  async searchApp(
    term: string,
    country: string,
    lang: string,
  ): Promise<GooglePlayAppInfoT[]> {
    const wa = getCurrWorkspaceAlias();
    const res = await defaultAxios.get<GooglePlayAppInfoT[]>(
      `/workspaces/${wa}/google_play/search?term=${term}&country=${country}&lang=${lang}`,
    );
    return res.data;
  },
  async disconnectApp(app_id: string): Promise<void> {
    await defaultAxios.delete(`/google_play/${app_id}`);
  },
};

export default googlePlayService;
